import React, { useEffect, useState } from 'react';
import * as componentStyle from './backToTopButton.module.scss';
import { FaArrowUp } from "react-icons/fa6";

export default function BackToTopButton() {

  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  
  return (
    <button
      className={componentStyle.backToTopButton}
      onClick={scrollToTop}
      aria-label="Back to top"
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? "scale(1)" : "scale(0.8)",
        transition: "all 0.4s ease-in-out",
      }}
    >
      <FaArrowUp />
    </button>
  )
}
